<template>
  <div class="row dmargin-top-20 dtop-seperator dmargin-lr-0" dir="rtl">
    <div class="col-12 info-row bottom-separator" :class="clazz" v-if="data.cook_and_me">
      <CookAndMeInCookPageComponent class="df18-l23" :cook_and_me="data.cook_and_me" />
    </div>
    <div class="col-12 info-row bottom-separator" :class="clazz">
      <CookAvailabilityComponent class="df18-l23" :availability="data.delivery_details" />
    </div>
    <div class="col-12 info-row bottom-separator " :class="clazz" v-if="data.delivery_details.minimum_order_price_for.carrier_delivery.available">
      <CookDeliveryComponent :details="data.delivery_details" />
    </div>
    <div class="col-12 info-row bottom-separator" :class="clazz">
      <CookContactComponent :contact="data.contact_info" />
    </div>
    <div class="col-12 info-row bottom-separator">
      <div class="d-flex flex-row f14-l23 df18-l23" :class="aligment()">
        <img src="@/assets/food_cover_icon.svg" class="spacer-left-small" style="width:17px; height:46px" />
        <div class="align-self-center">
          <span class="" v-for="(p,pkey) in data.preferences" :key="pkey">{{p.text}}<span v-if="pkey<Object.keys(data.preferences).length-1"> | </span> </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import {fetch3} from '@/modules/configuration.js'
import CookAvailabilityComponent from "@/components/cook/CookAvailabilityComponent.vue";
import CookContactComponent from "@/components/cook/CookContactComponent.vue";
import CookDeliveryComponent from "@/components/cook/CookDeliveryComponent.vue";
import CookAndMeInCookPageComponent from '@/components/cook/CookAndMeInCookPageComponent.vue';
export default {
  data() {
    return {
      data: {}
    };
  },
  props: {
    initialData: {},
    updateUrl: String
  },
  components: {
    CookAvailabilityComponent,
    CookContactComponent,
    CookDeliveryComponent,
    CookAndMeInCookPageComponent
  },
  methods: {
    aligment() {
      if (this.$isDesktop()) {
        return "items-align-center justify-content-center";
      } else {
        return "items-align-center justify-content-right";
      }
    },
    async getData(url) {
      const data = await fetch3(this, {
        url: url,
        method: "post",
        addQueryString: true
      });
      if (Object.keys(data).length ===0) return ;

      this.data = data.attributes;
    },
  },
  computed: {
    clazz() {
      if (this.data.cook_and_me) {
        return "col-xl-3";
      }
      else{
        return "col-xl-4";
      }
    }
  },
  created() {
    this.data = this.initialData;
  },
  mounted () {
    this.emitter.on("city-selected", () => {
      this.getData(this.updateUrl);
    });
  },
  unmounted() {
    this.emitter.off("city-selected");
  },
}
</script>
<style scoped>
div.info-row {
  /* line-height: 43px; */
  min-height: 43px;
  max-height: 90px;
}
</style>